(function () {
  'use strict';
  if (window.MisuAnalytics) return;
  var node = document.getElementById('MisuAnalyticsConfig'), cfg;
  try { cfg = JSON.parse(node && node.textContent || '{}'); } catch (_) { return; }
  if (!cfg.enabled || cfg.themeEditor || /\/(?:account|customer_authentication|checkouts?|orders|policies)(?:\/|$)|\/pages\/(?:privacy-choices|manage-subscription|contact)/i.test(location.pathname)) return;

  var VERSION = 1, PREFIX = 'misu.analytics.', DAY = 86400000;
  var EVENTS = ['misu_landing_view', 'misu_offer_selected', 'misu_cta_clicked', 'misu_cart_confirmed', 'misu_cart_updated', 'misu_cart_opened', 'misu_cart_error', 'misu_checkout_clicked', 'misu_section_viewed', 'misu_faq_opened', 'misu_gallery_selected', 'misu_video_started', 'misu_video_progress', 'misu_popup_impression', 'misu_popup_engaged', 'misu_popup_step_completed', 'misu_popup_email_submitted', 'misu_popup_cta_clicked', 'misu_popup_dismissed', 'misu_popup_error'];
  var STRINGS = ['offer_id', 'purchase_type', 'variant_id', 'selling_plan_id', 'cta_location', 'section_id', 'faq_id', 'media_id', 'popup_campaign_id', 'action', 'error_code', 'trigger', 'reason'];
  var NUMBERS = ['pouch_quantity', 'cart_value', 'renewal_value', 'item_quantity', 'percent', 'duration_seconds'];
  var TRAFFIC = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'creative_id'];
  var memory = {}, queue = [], sending = false, timer, failures = 0, started = false;
  var once = {}, tagQueue = [], tagTimer, endpoint = '';
  try {
    var parsed = new URL(cfg.endpoint);
    if (parsed.protocol === 'https:' && ['misu-subscription-automation.vercel.app', 'analytics.dailymisu.com'].indexOf(parsed.hostname) !== -1 && parsed.pathname === '/api/analytics-events' && !parsed.search && !parsed.hash) endpoint = parsed.href;
  } catch (_) {}
  function token(value, max) {
    return typeof value === 'string' && value.length <= (max || 100) && /^[a-zA-Z0-9_.~ -]+$/.test(value) ? value : '';
  }
  function read(key, local) {
    if (Object.prototype.hasOwnProperty.call(memory, key)) return memory[key];
    try { return JSON.parse((local ? localStorage : sessionStorage).getItem(PREFIX + key) || 'null'); }
    catch (_) { return memory[key] || null; }
  }
  function write(key, value, local) {
    memory[key] = value;
    try { (local ? localStorage : sessionStorage).setItem(PREFIX + key, JSON.stringify(value)); } catch (_) {}
  }
  function allowed(kind) {
    try {
      if (navigator.globalPrivacyControl) return false;
      if (window.MisuPrivacy) return kind === 'marketing' ? window.MisuPrivacy.allowsMarketing() : window.MisuPrivacy.allowsAnalytics();
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p[kind === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed']());
    } catch (_) { return false; }
  }
  function uuid() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + '-' + Math.random().toString(36).slice(2);
  }
  function cleanParams(value) {
    var out = {};
    STRINGS.forEach(function (key) { var v = token(value && String(value[key] == null ? '' : value[key])); if (v) out[key] = v; });
    NUMBERS.forEach(function (key) { var v = value && value[key]; if (typeof v === 'number' && isFinite(v) && v >= 0 && v <= 1000000) out[key] = Math.round(v * 100) / 100; });
    return out;
  }
  function campaign() {
    var result = {}, query = new URLSearchParams(location.search);
    if (!allowed('marketing')) return result;
    TRAFFIC.forEach(function (key) { var v = token(query.get(key)); if (v) result[key] = v; });
    return result;
  }
  function context() {
    var now = Date.now(), visitor = read('visitor', true), session = read('session');
    if (!visitor || !token(visitor.id) || now - visitor.createdAt > 90 * DAY) {
      visitor = { id: uuid(), createdAt: now }; write('visitor', visitor, true);
    }
    if (!session || !token(session.id) || now - session.lastAt > 30 * 60000) session = { id: uuid(), startedAt: now, campaign: campaign() };
    var current = campaign();
    if (Object.keys(current).length) session.campaign = current;
    if (!allowed('marketing')) session.campaign = {};
    session.lastAt = now; write('session', session);
    return { visitorId: visitor.id, sessionId: session.id, attribution: session.campaign || {} };
  }
  function persist() { write('queue', queue); }
  function pruneMarketing() {
    if (allowed('marketing')) return;
    queue.concat(tagQueue.map(function (item) { return item.event; })).forEach(function (event) { event.attribution = {}; event.marketingAllowed = false; });
    var session = read('session');
    if (session) { session.campaign = {}; write('session', session); }
    if (queue.length) persist();
  }
  function clear() {
    queue = []; tagQueue = []; memory = {}; clearTimeout(timer); clearTimeout(tagTimer); started = false; once = {};
    ['visitor', 'queue', 'session'].forEach(function (key) {
      try { localStorage.removeItem(PREFIX + key); sessionStorage.removeItem(PREFIX + key); } catch (_) {}
    });
  }
  function sendTags() {
    clearTimeout(tagTimer);
    if (!allowed()) { tagQueue = []; return; }
    var now = Date.now();
    tagQueue = tagQueue.filter(function (item) {
      if (now - item.created > 10000) return false;
      var event = item.event;
      if (!item.ga && /^G-[A-Z0-9]+$/.test(cfg.ga4MeasurementId || '') && typeof window.gtag === 'function') {
        try {
          var ad = {};
          ['creative_id', 'campaign_id', 'adset_id', 'ad_id'].forEach(function (key) { var value = token(event.attribution[key]); if (value && allowed('marketing')) ad[key] = value; });
          window.gtag('event', event.event, Object.assign({ send_to: cfg.ga4MeasurementId, event_id: event.eventId, landing_page_id: event.landingPageId, page_type: event.pageType, offer_version: cfg.offerVersion, currency: event.currency }, ad, event.params));
          item.ga = true;
        } catch (_) {}
      }
      if (!item.clarity && typeof window.clarity === 'function') {
        try {
          window.clarity('set', 'landing_page_id', event.landingPageId);
          if (event.params.offer_id) window.clarity('set', 'offer_id', event.params.offer_id);
          window.clarity('event', event.event); item.clarity = true;
        } catch (_) {}
      }
      return !item.ga || !item.clarity;
    });
    if (tagQueue.length) tagTimer = setTimeout(sendTags, 500);
  }
  function flush(beacon) {
    if (!allowed()) { clear(); return; }
    pruneMarketing();
    if (!endpoint || sending || !queue.length) return;
    queue = queue.filter(function (e) { return Date.now() - Date.parse(e.at) < DAY; });
    var batch = queue.slice(0, 20);
    if (!batch.length) { persist(); return; }
    if (beacon && navigator.sendBeacon) {
      try { navigator.sendBeacon(endpoint, new Blob([JSON.stringify(batch)], { type: 'text/plain;charset=UTF-8' })); } catch (_) {}
      return;
    }
    sending = true;
    fetch(endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(batch), keepalive: true })
      .then(function (r) { if (!r.ok) throw new Error('delivery_failed'); return r.json(); })
      .then(function (receipt) {
        if (!receipt.ok || !Array.isArray(receipt.acceptedIds)) throw new Error('invalid_receipt');
        queue = queue.filter(function (e) { return receipt.acceptedIds.indexOf(e.eventId) === -1; });
        failures = 0; if (allowed()) persist();
      }).catch(function () { failures += 1; })
      .finally(function () {
        sending = false;
        if (allowed() && queue.length && failures < 5) timer = setTimeout(flush, Math.min(30000, failures ? 1000 * Math.pow(2, failures) : 100));
      });
  }
  function track(name, params, suppliedId) {
    if (!allowed() || EVENTS.indexOf(name) === -1) return null;
    try {
      var ctx = context();
      var event = {
        schemaVersion: VERSION, eventId: token(suppliedId) || uuid(), event: name, at: new Date().toISOString(),
        visitorId: ctx.visitorId, sessionId: ctx.sessionId, attribution: ctx.attribution,
        pageType: token(cfg.pageType) || 'unknown', landingPageId: token(cfg.landingPageId) || 'default',
        currency: /^[A-Z]{3}$/.test(cfg.currency) ? cfg.currency : 'USD',
        offerVersion: token(cfg.offerVersion), analyticsAllowed: true, marketingAllowed: allowed('marketing'), params: cleanParams(params)
      };
      if (endpoint) { queue.push(event); queue = queue.slice(-100); persist(); clearTimeout(timer); timer = setTimeout(flush, 250); }
      tagQueue.push({ event: event, created: Date.now() }); tagQueue = tagQueue.slice(-100); sendTags();
      window.dispatchEvent(new CustomEvent('misu:analytics-recorded', { detail: event }));
      return event.eventId;
    } catch (_) { return null; }
  }
  function one(name, key, params) { if (!once[key] && track(name, params)) once[key] = true; }
  window.MisuAnalytics = { track: track, flush: flush, context: function () { return allowed() ? context() : null; }, version: VERSION };
  function start() {
    if (!allowed()) { clear(); return; }
    pruneMarketing();
    if (started) return;
    started = true;
    var saved = read('queue');
    queue = Array.isArray(saved) ? saved.filter(function (e) { return e && EVENTS.indexOf(e.event) !== -1 && Date.now() - Date.parse(e.at) < DAY; }).slice(-100) : [];
    track('misu_landing_view');
  }
  document.addEventListener('visitorConsentCollected', start);
  window.addEventListener('misu:privacy-changed', start);
  window.addEventListener('pagehide', function () { flush(true); });
  window.addEventListener('online', function () { failures = 0; flush(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(true); });

  document.addEventListener('change', function (e) {
    if (e.target.matches('#ProductForm [name="cadence"]')) {
      var el = e.target;
      track('misu_offer_selected', { offer_id: el.value === 'bundle' ? 'subscription_bundle' : 'subscription_single', purchase_type: 'subscription', variant_id: el.dataset.variantId, selling_plan_id: el.dataset.sellingPlan });
    }
  });
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-v3-plan], [data-gallery-src]');
    if (el && el.hasAttribute('data-v3-plan')) track('misu_offer_selected', { offer_id: el.dataset.v3Plan === '90' ? 'subscription_bundle' : el.dataset.v3Plan === 'once' ? 'one_time' : 'subscription_single', purchase_type: el.dataset.v3Plan === 'once' ? 'one_time' : 'subscription' });
    if (el && el.hasAttribute('data-gallery-src')) track('misu_gallery_selected', { media_id: 'image_' + Array.prototype.indexOf.call(document.querySelectorAll('[data-gallery-src]'), el) });
  }, true);
  document.addEventListener('toggle', function (e) {
    if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
    var entries = Array.prototype.slice.call(document.querySelectorAll('main details, .v3 details'));
    var index = entries.indexOf(e.target);
    if (index >= 0) track('misu_faq_opened', { faq_id: 'detail_' + index });
  }, true);
  var videos = Array.prototype.slice.call(document.querySelectorAll('main video, .v3 video'));
  videos.forEach(function (video, index) {
    var id = 'video_' + index;
    video.addEventListener('play', function () { one('misu_video_started', id + '_play', { media_id: id }); });
    video.addEventListener('timeupdate', function () {
      if (!isFinite(video.duration) || video.duration <= 0) return;
      [25, 50, 75, 95].forEach(function (percent) {
        if (video.currentTime / video.duration * 100 >= percent) one('misu_video_progress', id + '_' + percent, { media_id: id, percent: percent, duration_seconds: video.duration });
      });
    });
  });
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) one('misu_section_viewed', 'section_' + entry.target.dataset.misuAnalyticsSection, { section_id: entry.target.dataset.misuAnalyticsSection });
      });
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
    document.querySelectorAll('main section, .v3 > section').forEach(function (section, index) {
      section.dataset.misuAnalyticsSection = token(section.id) || 'section_' + index; observer.observe(section);
    });
  }
  start();
})();
